import { uniqBy } from 'lodash-es';
import type { FieldValueEnricher } from 'models/forms/fields/utils';
import type { Underlying } from 'models/underlying';

import type { FieldMetadataBase } from './FieldMetadataBase';

const TYPE = 'MultipleUnderlyingsField' as const;
export type MultipleUnderlyingsFieldMetadata = FieldMetadataBase<typeof TYPE>;

export const multipleUnderlyingsFieldValueEnricher: FieldValueEnricher<Underlying[]> = {
  isHandled: ({ type }) => type === TYPE,
  generateEnrichment(action, target, changes) {
    switch (action) {
      case 'add':
        return uniqBy([...target, ...changes], underlying => underlying.id);
      case 'replace':
        return changes;
    }
  },
};
